import type { CustomFile } from '../file';

export function isFileValid(file: CustomFile) {
  return !(
    file.extensionError ||
    file.emptyFileError ||
    file.fileSizeExceededError ||
    file.uploadError
  );
}
